import * as React from 'react';
export default (function (props) {
  return React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
});
//# sourceMappingURL=FilterDropdownMenuWrapper.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/FilterDropdownMenuWrapper.js
// module id = 839
// module chunks = 3